import React from "react";
import { Card, Typography, Space, Button } from "antd";
import {
  PhoneOutlined,
  MailOutlined,
  CrownOutlined,
} from "@ant-design/icons";

const { Title, Text, Paragraph } = Typography;

const ContactToUpgrade = () => {
  const phones = ["+260957886269", "+260768188181", "+260772824449"];
  const email = "info@kwachaplus.com";

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px 16px",
        minHeight: "60vh",
      }}
    >
      <Card
        style={{
          maxWidth: 520,
          width: "100%",
          textAlign: "center",
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
        }}
      >
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <CrownOutlined style={{ fontSize: 48, color: "#faad14" }} />

          <Title level={3} style={{ marginBottom: 0 }}>
            Contact Us to Upgrade Your Account
          </Title>

          <Paragraph type="secondary" style={{ marginBottom: 0 }}>
            Please get in touch with our team to upgrade your plan and
            continue enjoying uninterrupted access to KwachaPlus.
          </Paragraph>

          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            {phones.map((phone) => (
              <Button
                key={phone}
                type="default"
                size="large"
                icon={<PhoneOutlined />}
                href={`tel:${phone}`}
                block
              >
                {phone}
              </Button>
            ))}

            <Button
              type="primary"
              size="large"
              icon={<MailOutlined />}
              href={`mailto:${email}`}
              block
              style={{ backgroundColor: "#52c41a", borderColor: "#52c41a" }}
            >
              {email}
            </Button>
          </Space>
        </Space>
      </Card>
    </div>
  );
};

export default ContactToUpgrade;
